var exports = {
  "kL": "ChannelWebhooksTab.module__container___c3J2eH",
  "wx": "ChannelWebhooksTab.module__header___c3J2eH",
  "h_": "ChannelWebhooksTab.module__description___c3J2eH",
  "UD": "ChannelWebhooksTab.module__buttonContainer___c3J2eH",
  "dc": "ChannelWebhooksTab.module__spinnerContainer___c3J2eH",
  "Xb": "ChannelWebhooksTab.module__messageBox___c3J2eH",
  "PQ": "ChannelWebhooksTab.module__webhooksList___c3J2eH",
  "wp": "ChannelWebhooksTab.module__followedSection___c3J2eH",
  "Gf": "ChannelWebhooksTab.module__sectionTitle___c3J2eH",
  "yV": "ChannelWebhooksTab.module__sectionDescription___c3J2eH",
};

module.exports = exports;
